import { render, staticRenderFns } from "./ImageDialog.vue?vue&type=template&id=0678977b&scoped=true"
import script from "./ImageDialog.vue?vue&type=script&lang=js"
export * from "./ImageDialog.vue?vue&type=script&lang=js"
import style0 from "./ImageDialog.vue?vue&type=style&index=0&id=0678977b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678977b",
  null
  
)

export default component.exports